module.exports = __webpack_public_path__ + "img/role_joy.c5bf9faf.png";